import { SitterDashboardData } from 'us-web-services';
import { AlertWarning } from 'us-react-components/dist/AlertWarning/AlertWarning';
import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { generatePath, useNavigate } from 'react-router-dom';
import { Routes } from '../../Routes';
import { useDependencies } from '../../dependencies';

interface Props {
  dashboardData: SitterDashboardData;
}

const SitterStatsList = ({ dashboardData }: Props ): JSX.Element | null => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { stores } = useDependencies();
  const { sitter: { sitter } } = stores;
  const navigate = useNavigate();

  const goToCalendarPage = (): void => {
    navigate(Routes.sitter.calendar);
  };

  const goToCalendarPageAvailability = (): void => {
    navigate(`${Routes.sitter.calendar}?openAvailability=true`);
  };

  const goToStatsPage = (anchor: string): void => {
    navigate(`${generatePath(Routes.sitter.stats, { id: sitter?.id })}?anchor=${anchor}`);
  };

  const goToStatsPageBookingResponse = (): void => {
    goToStatsPage('booking-response-card');
  };

  const goToStatsPageReliability = (): void => {
    goToStatsPage('concerning-cancels-card');
  };

  return (<div>
    { dashboardData.showCalendarWarning && <AlertWarning title={t('pages.sitter.dashboard.stats.calendarWarning')} onClick={goToCalendarPage} /> }
    { dashboardData.showBookingWarning && <AlertWarning title={t('pages.sitter.dashboard.stats.bookingWarning')} onClick={goToStatsPageBookingResponse} /> }
    { dashboardData.showJobSeekingWarning && <AlertWarning title={t('pages.sitter.dashboard.stats.jobSeekingWarning')} onClick={goToCalendarPageAvailability} /> }
    { dashboardData.showReliabilityWarning && <AlertWarning title={t('pages.sitter.dashboard.stats.reliabilityWarning')} onClick={goToStatsPageReliability} /> }
  </div>)
};

export { SitterStatsList };
